import React from "react";
import "./Title.css";



function Title()
{
    return(
        <div className="title center">
            <h1>Daily Expense Manager</h1>
        </div>
    );
}

export default Title;